/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseBoolean
 */
export interface ResponseBoolean {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBoolean
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBoolean
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseBoolean
     */
    data?: boolean;
}

/**
 * Check if a given object implements the ResponseBoolean interface.
 */
export function instanceOfResponseBoolean(value: object): value is ResponseBoolean {
    return true;
}

export function ResponseBooleanFromJSON(json: any): ResponseBoolean {
    return ResponseBooleanFromJSONTyped(json, false);
}

export function ResponseBooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBoolean {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseBooleanToJSON(json: any): ResponseBoolean {
    return ResponseBooleanToJSONTyped(json, false);
}

export function ResponseBooleanToJSONTyped(value?: ResponseBoolean | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

